module.exports = __webpack_public_path__ + "media/grenada.a0aa0636.mp4";